<script>
    import * as d3 from 'd3';
    import { CASES_LINE_COLOR } from '../constants';
    import internationalLineChart from '../charts/internationalLineChart';

    export let data;

    let chartContainer;
    let chart;

    $: if (!chart && chartContainer && data) {
        chart = internationalLineChart()
                .data(data)
                .primaryLineColor(CASES_LINE_COLOR)
                .chartId('international-cases');
        d3.select(chartContainer).call(chart);
    }
</script>

<div class="chart-outer">
    <p class="description">Cases per million</p>
    <div bind:this={chartContainer} />
</div>
